import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'

const SectionGroup = ({ height, render }) => (
  <Scrollbars style={{ height }}>{render({})}</Scrollbars>
)

export default SectionGroup



// WEBPACK FOOTER //
// ./src/components/FilterMenu/sectionGroup.js